import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import { string, node, oneOfType } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';
import cn from 'classnames';

const IntlInput = ({ id, error, children, noErrorText, className = '', ...rest }) => {
  const props = { ...rest, id };
  return (
    <FormGroup className={cn(error ? 'has-error' : '', className)}>
      <Label for={id}>
        <FMessage id={id} />
      </Label>
      <Input {...props} />
      {children}
      {error && !noErrorText && <small className="form-text">{error}</small>}
    </FormGroup>
  );
};

IntlInput.propTypes = {
  id: string.isRequired,
  error: oneOfType([string, node]),
};

export default IntlInput;
